import { getCaseNumberAndType } from "us.collection.routines-and-activities/components/Note/Functions";
import {
  RegisteredUserType,
  ActivityStatusForPayload,
  ActivityTypesForPayload,
} from "us.collection/constants";
import { IMetaData } from "us.collection/interfaces";
import { NoteType, NoteSource } from "us.collection/constants";
import { CaseType, EntityType } from "us.helper/types/enums";

export function UpdateNotePayload(this: any) {
  const { values, noteId, location, metaData } = this ?? {};
  if (metaData.data) {
    const { caseNo, pid, type, eType } = getCaseNumberAndType(location, metaData.data);

    return {
      ...values,
      noteId,
      entityId: pid,
      entityType: type,
      dueDate: "",
      copyToActiveCases: false,
      copyToChildCreditors: false,
      manualDueDate: "",
      noteType: 0,
      activityParams: {
        entityId: caseNo,
        entityType: eType,
        activityType: !location?.pathname?.includes("history")
          ? ActivityTypesForPayload.MESSAGE
          : ActivityTypesForPayload.ALL,
        activityStatus: !location?.pathname?.includes("history")
          ? ActivityStatusForPayload.SUCCESS
          : ActivityStatusForPayload.ALL,
        registeredUserType: RegisteredUserType.ALL,
      },
    };
  } else {
    return {
      ...values,
      noteId,
      entityId: "",
      entityType: "",
      dueDate: "",
      copyToActiveCases: false,
      copyToChildCreditors: false,
      manualDueDate: "",
      noteType: 0,
      activityParams: {
        entityId: "",
        entityType: "",
        activityType: ActivityTypesForPayload.ALL,
        activityStatus: ActivityStatusForPayload.ALL,
        registeredUserType: RegisteredUserType.ALL,
      },
    };
  }
}

/**
 * @description Function to prepare payload for CP Note
 * @param this Form details
 * @param metaData 
 * @returns 
 */
export function SendDomainCPNote(this: any, metaData: IMetaData, note: string) {
  const { location, data } = this ?? {};
  const { caseNo, eType } = getCaseNumberAndType(location, metaData);
  return {
    entityId: caseNo,
    entityType: eType == CaseType.S ? EntityType.SUB_CASE : EntityType.CASE,
    messageContent: note,
    isInternal: false,
    isDebtorNote: false,
    communicationMethod: "note",
    manualDueDate: "",
    noteType: NoteType.CP_NOTE,
    source: NoteSource.US_BOX,
    noteCategoryId: data.noteCategoryId,
    activityParams: {
        entityId: caseNo,
        entityType: eType,
        activityType: !location?.pathname?.includes("history")
          ? ActivityTypesForPayload.MESSAGE
          : ActivityTypesForPayload.ALL,
        activityStatus: !location?.pathname?.includes("history")
          ? ActivityStatusForPayload.SUCCESS
          : ActivityStatusForPayload.ALL,
        registeredUserType: RegisteredUserType.ALL,
      },
  };
}